import { Component, Input } from '@angular/core';

@Component({
	selector: 'ea-anchor',
	templateUrl: './anchor.component.html',
	styleUrls: ['./anchor.component.scss']
})
export class AnchorComponent {
	@Input() href: string;
	// Default is routed link to run through Angular's router
	@Input() isRouterLink = true;
	@Input() target = '_self';
}
